import React from "react";
import { Flex } from "@jsq/ds/core";
import { Address, type DetailedPaymentPrefUnionObjectType } from "../../common/types";
import { AchPaymentPrefDisplay } from "./AchPaymentPrefDisplay";
import { CheckPaymentPrefDisplay } from "./CheckPaymentPrefDisplay";
import { WirePaymentPrefDisplay } from "./WirePaymentPrefDisplay";

export type PaymentPrefDetailsProps = {
  paymentPrefFull: DetailedPaymentPrefUnionObjectType;
  checkDisplayOverride?: {
    checkAddressOverride?: Address;
  };
};

export const PaymentPrefDetails: React.FC<PaymentPrefDetailsProps> = ({
  paymentPrefFull,
  checkDisplayOverride = {},
}: PaymentPrefDetailsProps) => {
  const achPaymentPref =
    paymentPrefFull?.__typename === "AchPaymentPrefObjectType" ? paymentPrefFull : undefined;

  const wirePaymentPref =
    paymentPrefFull?.__typename === "WirePaymentPrefObjectType" ? paymentPrefFull : undefined;

  const checkPaymentPref =
    paymentPrefFull?.__typename === "CheckPaymentPrefObjectType" ? paymentPrefFull : undefined;
  const { checkAddressOverride } = checkDisplayOverride;
  return (
    <Flex flexDirection="column">
      {achPaymentPref && <AchPaymentPrefDisplay achPaymentPrefFull={achPaymentPref} />}
      {wirePaymentPref && <WirePaymentPrefDisplay wirePaymentPrefFull={wirePaymentPref} />}
      {checkPaymentPref && (
        <CheckPaymentPrefDisplay
          checkPaymentPrefFull={checkPaymentPref}
          checkAddressOverride={checkAddressOverride}
        />
      )}
    </Flex>
  );
};
